import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import Swal from 'sweetalert2';
import { CustomerService } from '../customer-service.service';
import { UtilService } from 'src/app/services/util.service';
import { CustomValidator } from 'src/app/components/Helper/custom-validator';
import { BusinessProvider } from 'src/app/guard/business-details-guard.ts.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-add-user',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule,

    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class AddUserComponent extends FormValidation implements OnInit {
  public FORMERROR = super.Form;
  @Input('validation') isValidationOn: boolean = true;
  @Input() type: string
  businessData: any;
  domainMail: string;
  roles: any[] = [];
  constructor(private modalService: BsModalService, private API: ApiService, private util: UtilService,
    private customerService: CustomerService, private businessProvider : BusinessProvider,
  ) {
    super();

    const business = this.businessProvider.getBusiness();
    if(business){
      this.businessData = business;
      this.domainMail = '@' + business.businessEmail.split('@')[1];
    }

  }


  userForm !: FormGroup<any>;

  ngOnInit(): void {

    this.addUserForm();
    this.onEmailSearch();
    this.getListValue();
  }
  getRoleName(value: string): string {
    const role = this.roles.find(role => role.value === value);
    return role ? role.name : '';
  }

  getListValue() {
    const data = { "domain": "USER_TYPE" };
    this.API.create('listvalue/findbyList', data).subscribe(res => {
      if (res.code == '00000') {
        this.roles = res.data.USER_TYPE.listItems.map(ele => ({
          name: ele.item, value: ele.itemId
        }));
      }
    });
  }

  addUserForm() {

    this.userForm = new FormGroup({
      usersList: new FormArray([])
    });

    this.pushUserFields();
    // console.log(this.userForm);
  }

  get userFormArr() {
    return (this.userForm.get('usersList') as FormArray);
  }


  checkspace(event: any): boolean {
    return super.validSpace(event);
  }



  pushUserFields() {
    const fields = new FormGroup({
      firstName: new FormControl(null, [Validators.required, Validators.pattern(this.FIRST_Name.pattern),
      CustomValidator.checkWhiteSpace(), CustomValidator.max(this.FIRST_Name.max)]),
      lastName: new FormControl(null, [Validators.required, Validators.pattern(this.LAST_NAME.pattern),
      CustomValidator.checkWhiteSpace(), CustomValidator.max(this.LAST_NAME.max)]),
      email: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._-]+[a-zA-Z0-9]+$/),
        Validators.minLength(4),
        Validators.maxLength(this.EMAIL.max),
        CustomValidator.checkWhiteSpace(),
        this.preventPattern()
      ]),
      userType: new FormControl(null, [Validators.required]),
    });

    this.userFormArr.get('email')?.updateValueAndValidity();
    this.userFormArr.push(fields);
  }


  preventPattern(): (control: AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbiddenPattern = /^[a-zA-Z0-9-.]+$/;
      const isForbidden = forbiddenPattern.test(control.value);
      return isForbidden ? { 'forbiddenPattern': { value: control.value } } : null;
    };
  }


  name = "^[a-zA-Z ]*$";
  readonly EMAIL: any = {
    pattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    max: 50,
    domain: ["com", "net", "org", "info"],
  };


  preventInput(event: KeyboardEvent) {
    const blockedKeys = ['@', '#', '$', '%', '^', '&', '*', '(', ')', '!', '~', '`', '=', '+', '{', '}', '[', ']', ':', ';', '"', "'", '<', '>', '?', '/','\\',','];
    const key = event.key;
    if (blockedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  removeUser(index: number) {
    if (this.userFormArr.length > 1) {
      this.userFormArr.removeAt(index);
    } else {
      this.userFormArr.reset();


    }
    let data: Array<string> = this.userFormArr.controls.map(xc => {
      let d: string = xc.get('email').value;
      let data;
      if (d != null) {
        let val = d.split("@");
        if (val) {
          data = val[1];
        }
        return data;
      }
    });
    if (data && data.length === 0) {
      this.domainMisMatch = false;
      return;
    }
    const isEmailDomainSame: boolean = this.checkSameDomain(data);
    this.domainMisMatch = !isEmailDomainSame;

    const dataArr = this.userFormArr.controls;
    let data2: Array<string> = dataArr.map(xc => xc.get('email').value);
    const duplicates: Array<string> = this.findDuplicates(data2);


   if (duplicates) {
      dataArr.forEach(dt => {
        const val = dt.get('email').value;
 
        if (!val) {
          dt.get('email').setErrors({ required: true });
        }
        else if (duplicates.includes(val)) {
          dt.get('email').setErrors({ duplicatesFound: true });
        }
        else {
          dt.get('email').setErrors(null);
          dt.get('email').updateValueAndValidity({ onlySelf: true });
        }
      });
    }

  }


  closeModal() {
    this.modalService.hide(this.modalService.getModalsCount());
  }

  emailChangeSubject = new Subject<string>();
  onEmailChange() {
    this.emailChangeSubject.next("search");
  }

  domainMisMatch: boolean = false;
  mailPattern: RegExp = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;

  onEmailSearch() {
    this.emailChangeSubject.pipe(
      debounceTime(500)
    ).subscribe(data => {

      if (data === 'search') {
        const dataArr = this.userFormArr.controls;
        if (dataArr) {
          dataArr.forEach(dt => {
            const val = dt.get('email').value;
          });

          let data: Array<string> = dataArr.map(xc => {
            const value = xc.get('email').value;

            if (this.mailPattern.test(value)) {
              xc.get('email').setErrors({ emailBlocked: true });
              return true;
            }

            let d: string = xc.get('email').value + this.domainMail;
            let data;
            if (d != null) {
              let val = d.split("@");
              if (val) {
                data = val[1];
              }
              return data;
            }
          });

          let data2: Array<string> = dataArr.map(xc => xc.get('email').value);

          let emptyEmail = data2.some(item => item === "");

          if (emptyEmail) {
            return true
          }


          const validDomain = this.businessData.businessEmail.split('@')[1];
          let domainValid = data.every(x => x === validDomain);
          // console.log("1" , domainValid,  data , validDomain);
          // console.log("2" , data2);

          if (!domainValid) {

          }

          const duplicates: Array<string> = this.findDuplicates(data2);
          const isEmailDomainSame: boolean = this.checkSameDomain(data);

          this.domainMisMatch = !isEmailDomainSame;

         if (duplicates) {
            dataArr.forEach(dt => {
              const val = dt.get('email').value;
 
              if (!val) {
                dt.get('email').setErrors({ required: true });
              }
              else if (duplicates.includes(val)) {
                dt.get('email').setErrors({ duplicatesFound: true });
              }
              else {
                dt.get('email').setErrors(null);
                dt.get('email').updateValueAndValidity({ onlySelf: true });
              }
 
            });
          }
          //  else if(duplicates.length === 0 && this.userFormArr.status === 'INVALID'){

          //    let y =  dataArr.find(x=> x.get('email').hasError('duplicatesFound'));
          //    if(y){
          //     y.setErrors(null);
          //     y.updateValueAndValidity({onlySelf : true});
          //    }

          //  }

        }
      }

    });
  }

  checkSameDomain(d: Array<string>): boolean {
    if (d.length === 0) return false;

    let everyDomainIsSame: boolean = d.map((x) => {
      const firstD = d[0];

      if (x === '' || x === null || x === undefined) {
        return true;
      }

      if (x != firstD) {
        return false;
      }
      return true;
    }).every(c => c === true);

    return everyDomainIsSame;
  }

 findDuplicates(emails: string[]): string[] {
    const seen = new Set<string>();
    const duplicates = new Set<string>();
 
    for (const email of emails) {
      if (!email) continue;
      if (seen.has(email)) {
        duplicates.add(email);
      } else {
        seen.add(email);
      }
    }
 
    return Array.from(duplicates);
  }

  apiBeingCalled: boolean = false;

  saveUsers() {
    this.userForm.markAllAsTouched();
    // const usersListArray = this.userForm.get('usersList') as FormArray;
    // usersListArray.controls.forEach((group: FormGroup) => {
    //   Object.keys(group.controls).forEach((controlName) => {
    //     const control = group.get(controlName);
    //     if (control?.invalid) {
    //       console.log(control.value)
    //      }
    //   });
    // });




    const data = this.userForm.get('usersList') as FormArray;
    // const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailPattern = /^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   data.controls.forEach((userControl: AbstractControl, index: number) => {
      const email = userControl.get('email')?.value;
      if (!email) {
        userControl.get('email')?.setErrors({ required: true });
      } else {
        const userEmail = email + this.domainMail;
        if (!emailPattern.test(userEmail)) {
          userControl.get('email')?.setErrors({ pattern: true });
        } else {
          userControl.get('email')?.setErrors(null);
        }
      }
    });




    if (this.userForm.invalid) {
      return;
    }

    if (this.domainMisMatch) {
      return;
    }

    setTimeout(() => {
      if (this.userForm.valid && !this.domainMisMatch) {
        this.util.startLoader();
        const data = this.userForm.get('usersList').getRawValue();

        data.forEach(user => { user.email += this.domainMail; });


        this.apiBeingCalled = true;
        this.API.create(`user/onboardUsers?adminuserId=${localStorage.getItem('userId')}`, data)
          .subscribe(
            response => {
              setTimeout(() => {
                this.util.stopLoader();

                this.apiBeingCalled = false;

                if (response.code === AppSettings.SUCESS_CODE) {
                  this.modalService.hide(this.modalService.getModalsCount());

                  setTimeout(() => {
                    this.customerService.emitRefresh("user");
                  }, 1500);

                  Swal.fire({
                    icon: "success",
                    title: "User Onboard",
                    text: "Selected User Onboarded Successfully",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                } else if (response.code === '99998') {
                  const existUser = response.data.existingUsers;
                  if (existUser) {
                    for (let existMail of existUser) {
                      this.userFormArr.controls.forEach(cc => {
                        const email = cc.get('email').value + this.domainMail;
                        if (email.toLowerCase() === existMail.toLowerCase()) {
                          cc.get('email').setErrors({ existMail: true });
                        }
                      });
                    }
                  }
                }
              }, 500); // 500ms delay to ensure loader visibility
            }, err => {
              this.util.stopLoader();
              this.apiBeingCalled = false;
            });
      }
    }, 1000);

  }



  onRoleChange(event: any, index: number) {
    const value = (event != null && typeof event === 'object') ? event.value : event;
    this.userFormArr.at(index).get('userType').setValue(value);
  }
}
